import React from 'react';
import { TextInput, required } from 'react-admin';
import { generateTicketID } from '../../utils/formatting';

/**
 * Ticket ID field — must stay submittable (disabled inputs are omitted from save).
 */
export const TicketIdInput = ({ getSource }) => (
  <TextInput
    source={getSource('id')}
    label="Ticket ID"
    validate={required()}
    fullWidth
    InputProps={{ readOnly: true }}
    defaultValue={generateTicketID()}
    parse={(value) => (value && String(value).trim()) || generateTicketID()}
  />
);
